import ActionDialog from "@dashboard/components/ActionDialog";
import { ConfirmButtonTransitionState } from "@dashboard/components/ConfirmButton";
import ControlledCheckbox from "@dashboard/components/ControlledCheckbox";
import { Box } from "@saleor/macaw-ui-next";
import { FormattedMessage, useIntl } from "react-intl";

interface OrderMarkPickupReadyDialogProps {
  confirmButtonState: ConfirmButtonTransitionState;
  open: boolean;
  notifyCustomer: boolean;
  onClose: () => void;
  onConfirm: () => void;
  handleNotifyCustomer: (checked: boolean) => void;
}

const OrderMarkPickupReadyDialog = ({
  confirmButtonState,
  open,
  notifyCustomer,
  onClose,
  onConfirm,
  handleNotifyCustomer,
}: OrderMarkPickupReadyDialogProps) => {
  const intl = useIntl();

  return (
    <ActionDialog
      confirmButtonState={confirmButtonState}
      open={open}
      title={intl.formatMessage({
        id: "G70Z/a",
        defaultMessage: "Mark order ready for pickup",
        description: "dialog header",
      })}
      onClose={onClose}
      onConfirm={onConfirm}
    >
      <Box display="grid" gap={4}>
        <FormattedMessage
          id="1oYwQL"
          defaultMessage="Use it once the order is prepared at the store and the customer can come and collect it."
        />
        <ControlledCheckbox
          data-test-id="notify-customer"
          name="notifyCustomer"
          label={intl.formatMessage({
            id: "x4UlrT",
            defaultMessage: "Email the customer that the order is ready for pickup",
            description: "mark order ready for pickup, notify customer checkbox",
          })}
          checked={notifyCustomer}
          onChange={event => handleNotifyCustomer(event.target.value)}
        />
      </Box>
    </ActionDialog>
  );
};

OrderMarkPickupReadyDialog.displayName = "OrderMarkPickupReadyDialog";
export default OrderMarkPickupReadyDialog;
